<template>
	<!-- 填写信息 -->
	<div class="wid-100">
		<!--  -->
		<div class="" style="" v-show="$route.meta.showFather">
			<div class="box-shadow pad-16 mb-16">
				<div class="mb-16 flex-1">
					<div class="left-icon"></div>
					<p class="experts">收费明细</p>
				</div>
				<div class="flex-1">
					<p class="tiantou font-1">发票总额:</p>
					<p class="money money-1">￥{{form.amount}}</p>
				</div>
			</div>
			<div class="box-shadow pad-16 mb-16">
				<div>
					<el-form ref="form" :rules="rules" :model="form" :hide-required-asterisk="true" class="boc-form"
						label-width="80px">
						<el-form-item label="发票类型">
							<!-- <el-input v-model="form.invoiceType" disabled></el-input> -->
							<el-radio-group v-model="form.invoiceType"
								style="white-space: nowrap;">
								<el-radio label="电子普通发票">电子普通发票</el-radio>
								<el-radio label="增值税电子专用发票">增值税电子专用发票</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="抬头类型">
							<el-radio-group v-model="form.headingType" @change="checkRadio"
								style="white-space: nowrap;">
								<el-radio label="1">个人非企业</el-radio>
								<el-radio label="2">企业</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="发票抬头" prop="invoiceHeading" v-show="isShows">
							<el-input v-model="form.invoiceHeading" placeholder="抬头名称"></el-input>
						</el-form-item>
						<el-form-item label="企业税号" prop="enterpriseTaxNo" v-show="isShows">
							<el-input v-model="form.enterpriseTaxNo" placeholder="纳税人识别号或社会统一征信代码"></el-input>
						</el-form-item>
						<el-form-item label="企业地址" v-show="isShows">
							<el-input v-model="form.enterpriseAddress" placeholder="选填"></el-input>
						</el-form-item>
						<el-form-item label="企业电话" v-show="isShows">
							<el-input v-model="form.enterpriseMobile" placeholder="选填"></el-input>
						</el-form-item>
						<el-form-item label="开户银行" v-show="isShows">
							<el-input v-model="form.bankName" placeholder="选填"></el-input>
						</el-form-item>
						<el-form-item label="手机号码" prop="mobile">
							<el-input v-model="form.mobile" placeholder="请输入手机号码"></el-input>
						</el-form-item>
						<el-form-item label="电子邮箱" prop="email">
							<el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
						</el-form-item>
						<el-form-item label="邮寄地址" prop="mailAddress">
							<el-input v-model="form.mailAddress" placeholder="请输入邮寄地址"></el-input>
						</el-form-item>
					</el-form>
					<div class="flex-1 jus-bet">
						<div></div>
						<el-button type="primary" @click="submit(form)">提交申请</el-button>
						<div></div>
					</div>
				</div>
			</div>
		</div>
		<router-view></router-view>、
	</div>
</template>

<script>
	import {
		getApply
	} from '@/api/personal/api.js';
	export default {
		components: {},
		data() {
			// 自定义验证邮箱
			var checkEmail = (rule, value, callback) => {
				if (value === "") return callback(new Error('请输入邮箱'));
				const regEmail = /^([a-zA-Z0-9])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/;
				if (regEmail.test(value)) {
					return callback();
				} else {
					callback(new Error("请输入合法邮箱"));
				}
			};
			// 自定义验证手机号
			var checkPhone = (rule, value, callback) => {
				const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
				if (value.trim() !== "") {
					if (phoneReg.test(value)) {
						callback();
					} else {
						callback(new Error("请输入合法手机号"));
					}
				} else {
					callback(new Error('请输入手机号'));
				}
			};
			return {
				isShows: false,
				form: {
					amount: '',
					levelOrderIds: [],
					activityOrderIds: [],
					headingType: '1',
					invoiceType: '电子普通发票',
					invoiceHeading: '',
					enterpriseTaxNo: '',
					enterpriseAddress: '',
					enterpriseMobile: '',
					bankName: '',
					mobile: '',
					// 19945768474
					email: '',
					// 12345@163.com
					mailAddress: '',
				},
				rules: {
					invoiceHeading: [{
						required: true,
						message: '请输入抬头名称',
						trigger: 'blur'
					}],
					enterpriseTaxNo: [{
						required: true,
						message: '请输入企业税号',
						trigger: 'blur'
					}],
					mobile: [{
						trigger: 'blur',
						type: "number",
						validator: checkPhone,
					}],
					email: [{
						trigger: 'blur',
						validator: checkEmail,
					}],
				},

			}

		},
		created() {},
		mounted() {
			if (this.$route.params.types == 3) {
				this.form = JSON.parse(this.$route.params.form);
			}
			// console.log(this.$route.params,'cecece')
			this.form.amount = this.$route.params.amount;
			this.form.levelOrderIds = this.$route.params.levelOrderIds;
			this.form.activityOrderIds = this.$route.params.activityOrderIds;
			// this.status = this.$route.params.status;
		},
		methods: {
			checkRadio(value) {
				if (value == 2) {
					this.isShows = true;
				} else {
					this.isShows = false;
				}
				this.form.headingType = value;
				console.log(value, '')

			},
			submit(form) {
				this.$refs["form"].validate((valid) => {
					console.log(valid, 'valid')
					if (valid) {
						this.$router.push({
							name: '/invoice/submitApplication',
							params: form
						})
						// let params = this.form;
						// getApply(params).then(res => {
						//         if (res.code == 0) {
						//             this.$message.success('提交成功');
						//             this.$router.push('/personal/service/invoice/submitApplication')
						//         }
						//     })
						//     .catch(error => {

						//     });
					} else {}
				})

			},

		}
	}
</script>

<style>

</style>
<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-36 {
		padding: 36px 16px 51px 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.status {

		border-radius: 8px 8px 0 0;
		padding: 6px 0 5px 16px;
	}

	.status span {
		padding-right: 16px;
	}

	.tiantou {
		color: #999999;
		padding-right: 16px;
	}

	.money {
		color: #FFBA31;
	}

	.font-1 {
		font-size: 14px;
		font-family: font3;
		line-height: 21px;
	}

	.names {
		color: #222222;
	}

	.details {
		color: #333333;
		padding-right: 8px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.col-1 {
		color: #3ECC64;
		background-color: #EBFAEF;
	}

	.col-2 {
		color: #FF534D;
		background-color: #FFF0F0;
	}

	.col-3 {
		color: #FBB54C;
		background-color: #FFF6F0;
	}

	.pad-16 {
		padding: 16px;
	}

	.experts {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		padding-left: 10px;
	}

	.money-1 {
		font-family: font5;
	}

	.c-iocn {
		color: #999999;
		font-size: 14px;
		font-weight: 800;
	}

	.mb-55 {
		margin-bottom: 55px;
	}

	.w-25 {
		width: 32%;
		white-space: nowrap;
	}

	.w-25 .names {
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.el-button--primary {
		background-color: #3377FF;
		border-radius: 4px;
		padding: 0.75rem 3.625rem;
	}

	/deep/.el-button--primary span {
		font-size: 16px;
		color: #ffffff;
		font-family: font3;
		text-align: center;

	}

	.fapiao {
		width: 321px;
		height: 174px;
		margin-top: 24px;
	}

	.boc-form {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.boc-form .el-form-item {
		width: 41%;
	}

	/deep/.boc-form .el-form-item__label {
		padding-right: 16px;
		color: #222222;
		font-family: font3;
		font-size: 14px;
	}

	/deep/.el-radio__input.is-checked .el-radio__inner::after {
		border: 3px solid #ffffff;
		width: 5px;
		height: 7px;
		border-left: 0;
		border-top: 0;
		border-bottom: 3px solid #ffffff;
		top: 0;
		left: 2px;
		transform: rotate(45deg) scaleY(1.1);
		background: none;
		border-radius: 0px;


		/*      box-sizing: content-box;
            content: "";
            border: 1px solid #FFF;
            border-left: 0;
            border-top: 0;
            height: 0;
            left: 0;
            position: absolute;
            top: 1px;
            transform: rotate(45deg) scaleY(0);
            width: 3px;
            transition: transform .15s ease-in .05s;
            transform-origin: center; */
	}

	/deep/.el-radio__input.is-checked .el-radio__inner {
		background-color: #3377FF;
	}

	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #3377FF;
	}

	/deep/.el-input.is-disabled .el-input__inner {
		background-color: #EFEFEF;
		color: #222222;
		font-family: font3;
		font-size: 14px;

	}

	/deep/.el-input__inner {
		color: #222222;
		font-family: font3;
		font-size: 14px;
	}
</style>